var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":_vm.$t('label.customer')}}),_c('p',[_vm._v("Manage CRM application customers.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }